export default {
    pcd: "26A",
    pname: "京都府",
    cid: "ekyoto",
    terms: "26",
    unitdetails: "12,000円（1,000円×12枚）／1セット",
    ticketvalue: 12000,
    unitprice: 10000,
    maxunits: 2,
    quantityoptions: [
        {value: "1", text: "1"},
        {value: "2", text: "2"}
    ],
    starttime: "12:00",
    header: "京都府内限定　Go To Eatキャンペーン食事券　先着申込",
    explanation: "本サイトは、GoToEat食事券の先着申込受付サイトです。\nGoToEat食事券の申込方法をご案内しますので、以下同意したうえでメールアドレスのご登録をお願いいたします。",
    emaillead: "1メールアドレスあたり1回のみのお申し込みになります。",
    precautions: "★★★申込み以降のセット数の変更はできません★★★\n\n※※※※※※※※※※【注意事項】※※※※※※※※※※※※※※※※※※※\n●今回の食事券は1セット10,000円で12,000円分の食事券を購入できます。\n●20%のプレミアムとなります（25%ではございません。ご注意ください）\n●500円券はございません。1セットが1,000円券×12枚となります。\n※※※※※※※※※※※※※※※※※※※※※※※※※※※※※※※※※※※",
    sentmsg: {
        header: "メールアドレスのご登録",
        body: {
            lines: [
                "ご登録されたメールアドレスに、申込URLを送信しました。",
                "現時点では申込は完了しておりません。",
                "ご案内メールの申込URLより申込み手続きを行ってください。",
                "いかなる場合でも、メールの再送はできません。\n※メールを削除または紛失した場合は、再度受付サイトにてメールアドレスの登録手続きを行ってください。"
            ]
        },
        mailnotice: {
            header: "メールが届かない場合は以下をご確認ください。",
            items:[
               "迷惑メールボックスやごみ箱フォルダに入っていないかご確認ください。",
               "上記をご確認いただき、申込完了通知が届いていない場合は、「funity-rs.jp」からメールを受信出来るように設定のうえ、再度受付サイトにてメールアドレスの登録から、手続きを行ってください。"
            ]
        }
    },
    acceptbtn: "承諾して申込",
    startdatenotice: {
        title: "追加券先着 Web 申込みに関して",
        header: "",
        alert: "※※※※※※※※※※【注意事項】※※※※※※※※※※※※※※※※※※※\n●今回の食事券は1セット10,000円で12,000円分の食事券を購入できます。\n●20%のプレミアムとなります（25%ではございません。ご注意ください）\n●500円券はございません。1セットが1,000円券×12枚となります。\n※※※※※※※※※※※※※※※※※※※※※※※※※※※※※※※※※※※\n\n",
        body: "京都Go To Eatキャンペーン第４期追加食事券の先着 Web 申込みに関して、以下を確認の上、申込みを完了してください。",
        danger: "お引換開始は、お申込み日の翌々日12:00からとなります。",
        help: "",
        descriptions: [
            {
                term:"1. 申込みについて",
                definition: [
                    {text:"1メールアドレスあたり1回、2セットまでのお申込みになります。\n"},
                    {text:"※エイリアスメールを利用してのお申込みは、お控え頂きますようお願いいたします。"}
                ]
            },
            {
                term:"2. 申込み結果の通知について",
                definition: [
                    {text: "受付完了後、申込み完了通知がメールにて配信されます。\n"},
                    {text: "※申込み通知メールには発券に必要な引換票番号が書かれています。\n★★★いかなる場合も再送は致しません、各自で保管してください。\n　　　メールの自動削除設定をされている方はお気をつけください。★★★\n※登録後、メールアドレスの変更はできません。\n※今後新型コロナウイルス感染症拡大状況により、スケジュールは変更になる場合がございます。"},
                ],
            },
            {
                term:"3. 食事券の支払・発券について",
                definition:[
                    {text: "申込み完了通知に記載されている引換期限までにファミリーマート店舗で引き換えてください。\n"},
                    {text: "支払・発券期間：申込み完了通知に記載\n"},
                    {text: "支払・発券場所：全国のファミリーマート店内の Fami ポートでレシートを発券後レジにて支払・発券\n"},
                    {text: "※引換開始日は混雑が予想されます。\n　また、店舗が混雑する時間帯（昼11:30～13:30頃、夜 17:00～20:00頃）を避けて\n　ご来店いただけますよう、ご協力をお願いいたします。\n　なお、店舗により発券時間を制限をしている場合があります。\n　引換期限はゆとりをもたせていますので、慌てずに引換えてください。\n"},
                    {text: "※一部 Fami ポート端末を設置していない店舗もございます。\n"},
                    {text: "※一時的に食事券用紙在庫が切れる場合がございます。\n"},
                    {text: "※店舗によっては発券可能時間を設けている場合がございます。\n"},
                    {text: "※発券中の質問に関しては、Famiポートに設置の電話にてご質問ください。"},
                ]
            },
            {
                term:"4. 食事券に関する注意事項",
                definition:[
                    {text: "・お申込みの食事券は京都府内の登録された利用店舗でのみご利用いただけます。\n"},
                    {text: "・ファミリーマートでのお支払・お受取後の変更、払戻は、いかなる場合でも一切できません。\n"},
                    {text: "・利用店舗によっては利用額などの制限を設けている場合もございますので、事前に必ずご確認ください。\n"},
                    {text: "・食事券ご利用の際、おつりは出ません。"},
                ]
            },
            {
                term:"5．食事券ご利用に際しての感染拡大防止対策強化について",
                definition:[
                    {text: "農林水産省、京都府の要請により、京都GoToEatキャンペーン食事券をご利用頂く際の、新型コロナウィルス感染拡大防止対策強化について具体策が発表されています。\n"},
                    {text: "ご利用いただくお客様におかれましては、以下の注意事項をご確認の上、ご利用頂きますよう、お願いいたします。\n\n"},
                    {text: "・食事前、退店時の手指消毒をお願いします。\n"},
                    {text: "・長時間に及ばないようにしてください。\n"},
                    {text: "・会話は正しくマスクを着用して、大声は控えてください。\n"},
                    {text: "・2021年12月1日（水）以降は、利用店舗のうち、「京都府新型コロナウイルス感染防止対策認証」（第三者認証という）取得店舗での食事券利用に限ります。 \n"},
                    {text: "・ご協力いただけないお客様には食事券の利用を控えていただきます。 "},
                ]
            }
        ],
        footer: ""
    },
    completemsg: {
        header: "食事券の先着Web申込み｜先着Web申込み完了",
        body: {
            paragraphs: [
                {parts:[{text: "先着Web申込みを受付しました。"}]},
                {parts:[{text: "ご登録されたメールアドレスに、先着Web申込み完了通知を送信しました。内容をご確認ください。"}]},
                {parts:[{text: "※funity-rs.jp より、メールを配信いたします。\n　以下の設定方法をご確認頂き、「funity-rs.jp」からメールを受信出来るように設定をお願い致します。\n　https://www.funity-rs.jp/kyoto-lottery/#/help\n※迷惑メールフォルダに振り分けられている可能性もございますので、ご確認ください。\n\n"}]},
                {parts:[{text: "食事券の購入には、申込完了通知に記載の引換票番号が必要になります。\nメールに記載の入金発券期間にて、ファミリーマートでお支払い、食事券のお受け取りをお願いいたします。\n\n"}]},
                {parts:[{text: "※いかなる場合でも、メールの再送、引換票番号の再発行はできません。大切に保存ください。\nメールの自動削除設定をされている方はお気をつけください。"}]},
                {parts:[
                    {text: "■食事券に関する注意事項\n"},
                    {text: "・お申込みの食事券は京都府内の登録された利用店舗でのみご利用いただけます。\n"},
                    {text: "・2021年12月1日（水）以降は、利用店舗のうち、「京都府新型コロナウイルス感染防止対策認証」（第三者認証という）取得店舗での食事券利用に限ります。\n"},
                    {text: "・ファミリーマートでのお支払・お受取後の変更・払戻は、いかなる場合でも一切できません。\n"},
                    {text: "・利用店舗によっては利用額などの制限を設けている場合もございますので、事前に必ずご確認ください。\n"},
                    {text: "・食事券ご利用の際、おつりは出ません。\n"},
                ]},
            ]
        },
        mailnotice: {
            header: "",
            items:[
            ]
        },
        footer: {
            paragraphs: [
                {parts:[]}
            ]
        }
    },
};



